import { render, staticRenderFns } from "./EditUserProject.vue?vue&type=template&id=64cfeb6e&scoped=true&"
import script from "./EditUserProject.vue?vue&type=script&lang=ts&"
export * from "./EditUserProject.vue?vue&type=script&lang=ts&"
import style0 from "./EditUserProject.vue?vue&type=style&index=0&id=64cfeb6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cfeb6e",
  null
  
)

export default component.exports